const initialState = {
  innerWidth: 1920,
  //产品中心状态切换改变背景颜色的变量
  current: parseInt(sessionStorage.getItem('cateId')) || 0,
  //加入我们的表格索引
  tableLine: -1
};
const autoAdaptReducer = (state = initialState, action) => {
  console.log(state)
  console.log(action)
  switch (action.type) {
    case 'changeWidth':
      let newState1 = { ...state }
      console.log('changeWidth', action.value)
      newState1.innerWidth = action.value
      return newState1
    case 'changeCurrent':
      let newState2 = { ...state }
      console.log('changeCurrent', action.value)
      newState2.current = action.value
      return newState2
    case 'changeTableLine':
      let newState3 = { ...state }
      console.log('changeTableLine', action.value)
      newState3.tableLine = action.value
      return newState3
    case 'changeTableType':
      let newState4 = { ...state }
      console.log('changeTableType', action.value)
      newState4.tableType = action.value
      return newState4
    case 'getBaseOffset':
      let newState5 = { ...state }
      console.log('newState5', action.value)
      newState5.baseOffset = action.value
      return newState5
    case 'getOpt':
      let newState6 = { ...state }
      console.log('newState6', action.value)
      newState6.opt = action.value
      return newState6
    default:
      return state;
  }
}
export default autoAdaptReducer;
